<div class="_client-details-component inner-content">

	<ng-container *ngIf="type === 'info-line'">
		<info-line icon="./assets/icons/user-outline.svg">
			<p><span *ngIf="clientNavigationEnabled" [navigate]="[InternalNavigationType.page, '/internal/clienten/client', [NavigationDataKey.client, client]]">{{client.firstname}} {{client.lastname}}</span></p>
			<p *ngIf="!clientNavigationEnabled" >{{client.firstname}} {{client.lastname}}</p>
		</info-line>
	
		<info-line icon="./assets/icons/location-outline.svg" *ngIf="client.Address">
			<p [navigate]="[InternalNavigationType.address, client.Address]">{{client.Address | address}}</p>
		</info-line>

		<info-line icon="./assets/icons/email-outline.svg" *ngIf="client.email">
			<p [navigate]="[InternalNavigationType.email, client.email]">{{client.email}}</p>
		</info-line>		
	
		<info-line icon="./assets/icons/mobile-outline.svg" *ngIf="client.telephone">
			<p [navigate]="[InternalNavigationType.phone, client.telephone]">{{client.telephone}}</p>
		</info-line>

		<info-line icon="./assets/icons/phone-outline.svg" *ngIf="client.landline">
			<p [navigate]="[InternalNavigationType.phone, client.landline]">{{client.landline}}</p>
		</info-line>		
	
		<info-line icon="./assets/icons/calendar-outline.svg" align="top" *ngIf="client.birthDate">
			<p [translate]="'CLIENT.EXTRA.BIRTH_DATE'"></p>
			<p>{{client.birthDate | date:"d MMM yyyy"}}</p>
		</info-line>
	
		<ng-container *ifUserHasPermissions="[UserPermissions.ReadClientsSocial]">
			<info-line icon="./assets/icons/calendar-outline.svg" align="top" *ngIf="client.social">
				<p [translate]="'CLIENT.EXTRA.SOCIAL'"></p>
				<p>{{client.social}}</p>
			</info-line>
		</ng-container>

		<info-line icon="./assets/icons/employees-outline.svg" align="top" *ngIf="client.digibankTargetAudience">
			<p [translate]="'CLIENT.DIGIBANK_TARGET_AUDIENCE.TITLE'"></p>
			<p>{{client.digibankTargetAudience}}</p>
		</info-line>
		
		<info-line icon="./assets/icons/device-outline.svg" align="top" *ngIf="client.devices">
			<p [translate]="'CLIENT.EXTRA.DEVICES'"></p>
			<p>{{client.devices}}</p>
		</info-line>
		
		<info-line icon="./assets/icons/info-outline.svg" align="top" *ngIf="client.note">
			<p [translate]="'CLIENT.EXTRA.NOTE'"></p>
			<p>{{client.note}}</p>
		</info-line>		
	</ng-container>

	<ng-container *ngIf="type === 'basic'">
		<p class="_info-line-no-icon">
			<b>{{'CLIENT.NAME' | translate}}: </b><span [navigate]="[InternalNavigationType.page, '/internal/clienten/client', [NavigationDataKey.client, client]]">{{client.firstname}} {{client.lastname}}</span><br>
			<b>{{'CLIENT.ADDRESS' | translate}}: </b><span [navigate]="[InternalNavigationType.address, client.Address]">{{client.Address | address}}</span><br>
			<b>{{'CLIENT.CONTACT.PHONE' | translate}}: </b><span [navigate]="[InternalNavigationType.phone, client.telephone]">{{client.telephone}}</span><br>
			<b>{{'CLIENT.CONTACT.EMAIL' | translate}}: </b><span [navigate]="[InternalNavigationType.email, client.email]">{{client.email}}</span><br>
		</p>
	</ng-container>

</div>